module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/duplex-browser.js
// module id = 308
// module chunks = 0